module.exports = __webpack_public_path__ + "img/dawsonhall-h-474x356.3fea29fa.jpg";